import { Flex, Space, Text, Title } from '@mantine/core';
import { useIntl } from 'react-intl';

import { PageLoading } from '@/pages/PageLoading';
import { useArtistAbout } from '@/pages/artist/onboard/components/stages/about/hooks/useArtistAbout.ts';
import { APP_CONST } from '@/shared/constants';
import { LBModalLayout } from '@/shared/layouts';
import { LBButton, LBTextArea } from '@/shared/ui-kit/components';

export const ArtistAbout = () => {
  const { state, functions } = useArtistAbout();
  const { formatMessage } = useIntl();

  if (state.isLoading) return <PageLoading />;

  return (
    <>
      <LBModalLayout opened={state.modal.opened} onClose={state.modal.close}>
        <Space h={4} />
        <Flex>
          <Title order={2}>
            {formatMessage({ id: 'popups.confirmOnboardingCompletion.title' })}
          </Title>
        </Flex>
        <Space h={32} />
        <Text>
          {formatMessage({
            id: 'popups.confirmOnboardingCompletion.description'
          })}
        </Text>
        <Space h={32} />
        <LBButton
          fullWidth
          bg='var(--base-context-succes-main)'
          c='white'
          onClick={() => {
            localStorage.setItem(
              APP_CONST.LOCAL_STORAGE.IS_FIRST_LOGIN,
              JSON.stringify(false)
            );
            functions.toProfile();
          }}
        >
          {formatMessage({ id: 'commons.super' })}
        </LBButton>
      </LBModalLayout>
      <form onSubmit={functions.onSubmit}>
        <Title order={1}>
          {formatMessage({ id: 'pages.onboarding.artist.about.title' })}
        </Title>
        <Space h={8} />
        <Text fz={14}>
          {formatMessage({ id: 'pages.onboarding.artist.about.description' })}
        </Text>
        <Space h={32} />
        <LBTextArea
          key={state.form.key('about')}
          autosize
          disabled={state.form.submitting}
          minRows={4}
          description={formatMessage({
            id: 'pages.onboarding.artist.about.textAreaDescription'
          })}
          placeholder={formatMessage({
            id: 'pages.onboarding.artist.about.textAreaPlaceholder'
          })}
          {...state.form.getInputProps('about')}
        />
        <Space h={32} />
        <LBButton
          fullWidth
          disabled={!state.form.isValid('about')}
          loading={state.form.submitting}
          type='submit'
        >
          {formatMessage({ id: 'commons.finish' })}
        </LBButton>
      </form>
    </>
  );
};
